import { render, staticRenderFns } from "./StepContainer.vue?vue&type=template&id=fda5a512&"
import script from "./StepContainer.vue?vue&type=script&lang=js&"
export * from "./StepContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports